import { Icon } from '@chakra-ui/react';

export const CustomBulbIcon = (props) => {
  const { color, width = 17, height = 22, ...rest } = props || {};
  const strokeMain = color ? 'currentColor' : 'url(#paint0_linear_1467_1816)';
  const strokeSecondary = color
    ? 'currentColor'
    : 'url(#paint1_linear_1467_1816)';

  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 17 22"
      fill="none"
      color={color}
      {...rest}
    >
      <path
        d="M6.00106 18.5012C6.00106 17.7872 6.00106 17.4312 5.96206 17.1942C5.84006 16.4312 5.81906 16.3822 5.33206 15.7822C5.18006 15.5952 4.62006 15.0942 3.50006 14.0902C2.36794 13.0776 1.56995 11.7452 1.21166 10.2692C0.853365 8.79316 0.95167 7.24315 1.49356 5.82422C2.03545 4.4053 2.99539 3.18434 4.24636 2.3229C5.49733 1.46147 6.98037 1.00015 8.49925 1C10.0181 0.999848 11.5013 1.46086 12.7524 2.32205C14.0035 3.18324 14.9637 4.404 15.5059 5.82282C16.0481 7.24164 16.1467 8.79164 15.7887 10.2677C15.4307 11.7438 14.633 13.0764 13.5011 14.0892C12.3801 15.0932 11.8201 15.5952 11.6691 15.7812C11.1821 16.3812 11.1611 16.4302 11.0381 17.1932C11.0001 17.4302 11.0001 17.7872 11.0001 18.5002H6.00006C6.00006 19.4352 6.00006 19.9022 6.20106 20.2502C6.33271 20.4782 6.52205 20.6676 6.75006 20.7992C7.09806 21.0002 7.56506 21.0002 8.50006 21.0002C9.43506 21.0002 9.90206 21.0002 10.2511 20.8002C10.4791 20.6686 10.6684 20.4792 10.8001 20.2512C11.0011 19.9032 11.0011 19.4362 11.0011 18.5012"
        stroke={strokeMain}
        strokeWidth="1.5"
      />
      <path
        d="M8.49958 16V14M8.49958 14C8.85063 14 9.19551 13.9075 9.49953 13.732C9.80356 13.5565 10.056 13.304 10.2316 13M8.49958 14C8.14852 14 7.80365 13.9075 7.49962 13.732C7.19559 13.5565 6.94312 13.304 6.76758 13"
        stroke={strokeSecondary}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      {!color && (
        <defs>
          <linearGradient
            id="paint0_linear_1467_1816"
            x1="8.5"
            y1="1"
            x2="8.5"
            y2="21.0002"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.164982" stopColor="#FF9554" />
            <stop offset="1" stopColor="#FF4935" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_1467_1816"
            x1="8.49958"
            y1="13"
            x2="8.49958"
            y2="16"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.164982" stopColor="#FF9554" />
            <stop offset="1" stopColor="#FF4935" />
          </linearGradient>
        </defs>
      )}
    </Icon>
  );
};
